// hooks/useNavigateWithTags.js
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addTag, clickTag } from '../store/tagSlice';

export function useNavigateWithTags() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const mainTags = useSelector(state => state.tag?.value || []);
    
    const navigateWithTags = (path, label) => {
        // 先导航
        navigate(path);
        
        // 判断标签是否已存在
        const exists = mainTags.some(tag => tag.key === path);
        
        if (exists) {
            // 如果标签已存在，只激活它
            dispatch(clickTag(path));
        } else {
            // 如果标签不存在，添加并激活
            // const newTags = [...mainTags, { key: path, label }];
            dispatch(addTag({
                key: path,
                label: label
            }));
        }
    };
    
    return navigateWithTags;
}